import React from 'react';
import Form from "../../common/Form";
import JoiBase from "joi";
import {FormattedMessage, injectIntl} from "react-intl";
import JoiDate from "@hapi/joi-date";
import DisplayFormErrors from "../../common/formElements/DisplayFormErrors";
import {withRouter} from "react-router-dom";
import {UpdatePreference, CreateNewPreference} from "../../../../services/preferencesService";
import "./PreferenceForm.css";

const Joi = JoiBase.extend(JoiDate); // extend Joi with Joi Date

class PreferenceForm extends Form {

    state = {
        locale : this.props.locale,
        interest : this.props.interest,

        errors:{}
    }

    constructor(props) {
        super(props);
        const currentPreference = this.props.preference;
        this.state.sendButtonDisabled = false;

        this.state.data = {
            id : currentPreference.id,
            active : (currentPreference.active === 1)?true:false,
            fr : currentPreference.fr,
            en : currentPreference.en,
            clientOnly: (currentPreference.clientOnly === 1)?true:false,
            sponsorOnly: (currentPreference.sponsorOnly === 1)?true:false,
            priorityLevel: currentPreference.priorityLevel,

            errors:[]
        };

    }

    schemaDefinition = {
        id: Joi.number(),
        active : Joi.boolean(),
        fr: Joi.string().required(),
        en : Joi.string().required(),
        clientOnly: Joi.boolean(),
        sponsorOnly: Joi.boolean(),
        priorityLevel: Joi.number().required()
    };

    doSubmit = async e => {
        this.setState({sendButtonDisabled:true})
        let preferenceObject = {...this.state.data};

        delete preferenceObject.errors;
        if(preferenceObject.id){
            try{
                await UpdatePreference(preferenceObject);
              //this.props.history.push(`/${this.state.locale}/home`);
              this.props.history.goBack();
            }catch(err){
                console.error(err.message);
            }
        }
        else{
            try{
                await CreateNewPreference(preferenceObject);
                this.props.history.goBack();
            }catch(err){
                console.error(err.message);
            }
        }
    };

    getPriorityScale = () => {
        const isFrench = this.props.intl.locale === "fr";

        return [
            {
                value: 10,
                label: isFrench ? "Tres elevee" : "Very high",
                description: isFrench ? "Prise en compte en premier lors des matchs." : "Considered first during matching."
            },
            {
                value: 20,
                label: isFrench ? "Elevee" : "High",
                description: isFrench ? "Importante, mais apres le niveau 10." : "Important, but after level 10."
            },
            {
                value: 30,
                label: isFrench ? "Moyenne" : "Medium",
                description: isFrench ? "Priorite standard pour une preference utile." : "Standard priority for a useful preference."
            },
            {
                value: 40,
                label: isFrench ? "Faible" : "Low",
                description: isFrench ? "Prise en compte plus tard dans l'ordre de tri." : "Considered later in the ordering."
            },
            {
                value: 50,
                label: isFrench ? "Tres faible" : "Very low",
                description: isFrench ? "A utiliser pour une preference secondaire." : "Use for a secondary preference."
            }
        ];
    }

    handlePriorityPresetClick = value => {
        const errors = { ...this.state.errors };
        const errorMessage = this.validateProperty({ name: "priorityLevel", value });
        if (errorMessage) errors.priorityLevel = errorMessage;
        else delete errors.priorityLevel;

        const data = { ...this.state.data };
        data.priorityLevel = value;

        this.setState({ data, errors });
    };

    renderPriorityConfigurator() {
        const isFrench = this.props.intl.locale === "fr";
        const priorityScale = this.getPriorityScale();
        const currentPriority = Number(this.state.data.priorityLevel);
        const selectedPriority = priorityScale.find(item => item.value === currentPriority);

        return (
            <div className="preference-priority-panel">
                <div className="preference-priority-intro">
                    <strong>{isFrench ? "Ordre de prise en compte" : "Matching order"}</strong>
                    <p>
                        {isFrench
                            ? "Les plus petits chiffres sont analyses en premier lors des matchs. Les reperes proposes sont 10, 20, 30, 40 et 50, ce qui vous permet d'utiliser des valeurs intermediaires comme 15 ou 25 lorsque vous voulez nuancer l'ordre."
                            : "Smaller numbers are considered first during matching. Suggested anchors are 10, 20, 30, 40 and 50, which lets you use intermediate values like 15 or 25 when you need finer ordering."}
                    </p>
                </div>

                <div className="preference-priority-scale" role="group" aria-label={isFrench ? "Choix du niveau de priorite" : "Priority level choices"}>
                    {priorityScale.map(option => (
                        <button
                            key={option.value}
                            type="button"
                            className={currentPriority === option.value ? "preference-priority-option is-active" : "preference-priority-option"}
                            onClick={() => this.handlePriorityPresetClick(option.value)}
                        >
                            <span className="preference-priority-number">{option.value}</span>
                            <span className="preference-priority-copy">
                                <strong>{option.label}</strong>
                                <small>{option.description}</small>
                            </span>
                        </button>
                    ))}
                </div>

                <div className="preference-priority-summary">
                    <span className="preference-priority-summary-value">{Number.isFinite(currentPriority) ? currentPriority : "-"}</span>
                    <div>
                        <strong>
                            {selectedPriority
                                ? selectedPriority.label
                                : isFrench
                                    ? "Valeur personnalisee"
                                    : "Custom value"}
                        </strong>
                        <p>
                            {selectedPriority
                                ? selectedPriority.description
                                : isFrench
                                    ? "Vous pouvez saisir une valeur intermediaire comme 15 ou 25 pour positionner plus finement cette preference entre deux niveaux predéfinis."
                                    : "You can type an intermediate value like 15 or 25 to position this preference between two predefined levels."}
                        </p>
                    </div>
                </div>

                <div className="preference-priority-manual-input">
                    {this.renderInput("priorityLevel", "preference.form.priorityLevel", false, "number")}
                </div>
            </div>
        );
    }


    render() {
        const isFrench = this.props.intl.locale === "fr";

        return (
            <>
                <div className="container preference-form-page">
                    <h1><FormattedMessage id="preference.form.h1" /> {this.props.preference.id}</h1>
                    <DisplayFormErrors
                        errors = {this.state.data.errors}
                    />

                    <form onSubmit={this.handleSubmit} className="preference-form-shell">
                        <div className="preference-form-grid">
                            <section className="preference-form-card">
                                <h2><FormattedMessage id="preference.form.h2" /></h2>
                            {this.renderInput("fr", "preference.form.fr")}
                            {this.renderInput("en", "preference.form.en")}
                            </section>

                            <section className="preference-form-card">
                                <h2>{isFrench ? "Visibilite" : "Visibility"}</h2>
                                {this.renderCheckBox("active", "preference.form.active")}
                                {this.renderCheckBox("clientOnly", "preference.form.clientOnly")}
                                {this.renderCheckBox("sponsorOnly", "preference.form.sponsorOnly")}
                            </section>

                            <section className="preference-form-card preference-form-card--priority">
                                <h2>{isFrench ? "Priorite de matching" : "Matching priority"}</h2>
                                {this.renderPriorityConfigurator()}
                            </section>
                        </div>

                        <div className="preference-form-actions">
                            <button disabled={this.state.sendButtonDisabled} className="btn btn-primary">
                                {this.state.sendButtonDisabled ? <FormattedMessage id="preference.form.savingChanges"/> : <FormattedMessage id="preference.form.saveChanges"/>}
                            </button>
                        </div>

                    </form>
                </div>
            </>
        );
    }
}

export default withRouter(injectIntl(PreferenceForm));
